import api from './api';

export const couponService = {
  // Get all coupons (for vendor)
  getCoupons: async () => {
    const response = await api.get('/coupons');
    return response.data;
  },

  // Get single coupon
  getCoupon: async (id) => {
    const response = await api.get(`/coupons/${id}`);
    return response.data;
  },

  // Validate coupon code
  validateCoupon: async (code, orderTotal) => {
    const response = await api.post('/coupons/validate', { code, orderTotal });
    return response.data;
  },

  // Create coupon
  createCoupon: async (couponData) => {
    const response = await api.post('/coupons', couponData);
    return response.data;
  },

  // Update coupon
  updateCoupon: async (id, couponData) => {
    const response = await api.put(`/coupons/${id}`, couponData);
    return response.data;
  },

  // Delete/deactivate coupon
  deleteCoupon: async (id) => {
    const response = await api.delete(`/coupons/${id}`);
    return response.data;
  },

  // Apply coupon to order
  applyCoupon: async (id, orderTotal) => {
    const response = await api.post(`/coupons/${id}/apply`, { orderTotal });
    return response.data;
  },
};

